import { useOktaAuth } from '@okta/okta-react';
import { mapPlaylistFromVideoSearch } from 'yankees-react-utils';
import { useContext } from 'react';
import { Video } from './data';
import { store } from '../store';

const useMultiVideoFn = () => {
    const { authState: { accessToken } } = useOktaAuth();
    const { state: { user } } = useContext(store);

    if (window.$IsDugoutApp) {
        return null;
    }
    return async (pitches) => {
        const resp = await Video.multi(accessToken, JSON.stringify(pitches.map((x) => ({ g: x.gameid, e: x.eventseq, p: x.pitchseq }))));
        return mapPlaylistFromVideoSearch({ videos: resp.videos, playervideos: [] }, user.Roles.map((r) => r.RoleName));
    };
};

export default useMultiVideoFn;
